import React from 'react';

const Shine = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "30",
    viewBox: "0 0 28 30",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.0778 16.8288C27.0151 9.61986 22.5214 2.93061 16.0407 1.88794C9.5601 0.845261 3.54665 5.84399 2.60931 13.0529C1.67197 20.2619 6.1657 26.9511 12.6463 27.9938C19.127 29.0365 25.1404 24.0377 26.0778 16.8288Z",
      fill: "url(#paint0_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6159 15.4981C8.86923 18.9893 4.08894 21.5718 3.93724 21.2643C3.78666 20.9568 8.32198 17.8768 14.0687 14.3856C19.8153 10.8943 24.5956 8.31183 24.7473 8.61933C24.8979 8.92683 20.3626 12.0068 14.6159 15.4981Z",
      fill: "url(#paint1_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.2554 15.2748C10.8056 14.1485 8.04691 13.086 8.09636 12.901C8.14468 12.716 10.9821 13.4798 14.4319 14.606C17.8817 15.7323 20.6393 16.7948 20.591 16.9798C20.5426 17.1648 17.7053 16.401 14.2554 15.2748Z",
      fill: "url(#paint3_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.0429 14.8426C15.0554 11.0038 16.0106 7.93634 16.1769 7.99134C16.3432 8.04509 15.6566 11.2013 14.6441 15.0388C13.6317 18.8763 12.6765 21.9451 12.5102 21.8901C12.3439 21.8363 13.0305 18.6801 14.0429 14.8426Z",
      fill: "url(#paint4_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.3904 15.401C9.66519 16.0085 5.81309 16.296 5.78724 16.0435C5.76139 15.791 9.5708 15.0935 14.296 14.486C19.0213 13.8785 22.8733 13.591 22.8992 13.8447C22.925 14.0972 19.1156 14.7935 14.3904 15.401Z",
      fill: "url(#paint5_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.9329 14.9891C13.3868 9.73284 13.1283 5.44784 13.3564 5.41909C13.5834 5.39034 14.2104 9.62784 14.7566 14.8841C15.3027 20.1403 15.5611 24.4253 15.333 24.4541C15.106 24.4828 14.479 20.2453 13.9329 14.9891Z",
      fill: "url(#paint6_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.202 15.1394C12.1546 13.3344 10.5589 11.7819 10.6376 11.6719C10.7151 11.5619 12.4378 12.9369 14.4852 14.7419C16.5314 16.5469 18.1282 18.0994 18.0496 18.2094C17.972 18.3194 16.2494 16.9444 14.202 15.1394Z",
      fill: "url(#paint7_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.1638 14.7854C15.7865 12.5079 17.1821 10.7329 17.281 10.8192C17.3799 10.9054 16.1438 12.8217 14.5212 15.0992C12.8985 17.3767 11.5029 19.1517 11.404 19.0654C11.3051 18.9792 12.5401 17.0629 14.1638 14.7854Z",
      fill: "url(#paint8_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.0406 20.4392C14.3111 22.0979 10.8905 20.9804 9.39935 17.9454C7.90818 14.9092 8.91278 11.1042 11.6412 9.44544C14.3707 7.78669 17.7913 8.90419 19.2824 11.9392C20.7736 14.9742 19.769 18.7804 17.0406 20.4392Z",
      fill: "url(#paint9_radial_24455_927260)"
    }
  ),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint0_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.3433 14.9391) rotate(63.8456) scale(12.8947 12.1267)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#8FC5E1" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1", stopOpacity: "0.1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint1_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.3915 15.0386) rotate(63.7986) scale(0.618842 12.1264)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint2_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(15.3632 14.3133) rotate(148.662) scale(0.58436 12.8396)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint3_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.5748 14.0246) rotate(104.719) scale(0.344888 6.55824)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint4_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(15.5008 15.3309) rotate(-161.993) scale(0.315315 7.17332)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint5_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.2505 14.0059) rotate(84.0942) scale(0.459202 8.62185)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint6_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(15.1512 14.8321) rotate(172.706) scale(0.413971 9.56393)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint7_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(15.0669 13.9306) rotate(125.488) scale(0.242949 4.91411)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint8_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.492 15.0599) rotate(-138.58) scale(0.237147 5.03433)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ), /* @__PURE__ */ React.createElement(
    "radialGradient",
    {
      id: "paint9_radial_24455_927260",
      cx: "0",
      cy: "0",
      r: "1",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(14.3395 14.9397) rotate(63.8456) scale(6.12411 5.75934)"
    },
    /* @__PURE__ */ React.createElement("stop", { stopColor: "#8FC5E1" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.026", stopColor: "#7DADC5" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.07", stopColor: "#63899C" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.12", stopColor: "#4B6877" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.175", stopColor: "#374B56" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.235", stopColor: "#25343B" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.303", stopColor: "#172025" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.382", stopColor: "#0D1114" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.48", stopColor: "#050708" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "0.618", stopColor: "#010101" }),
    /* @__PURE__ */ React.createElement("stop", { offset: "1" })
  ))
);

export { Shine };
//# sourceMappingURL=Shine.js.map
